import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { IPastStockQuantity } from '../types';

class PastStockQuantityService extends BaseService<IPastStockQuantity> {
  constructor() {
    super('past-stock-quantities');
  }

  exportAll = async (params: Record<string, unknown>) => {
    axiosPrivate
      .get(`${this.modulePrefix}/export/`, {
        params,
        responseType: 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
}

export const pastStockQuantityService = new PastStockQuantityService();
